<template>
	<div class="agreement">
		<template v-if="isSubscribe">
			{{ t('billing.agreement.subscription', { price: localizedPrice }) }}
		</template>
		<template v-else>
			{{ t('billing.agreement.purchase') }}
		</template>
	</div>
</template>

<script setup>
import { computed } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'

const props = defineProps({
	localizedPrice: {
		type: String,
		required: true
	},

	mode: {
		type: String,
		validation: (value) => ['subscribe', 'purchase'].includes(value),
		default: 'subscribe'
	}
})

const isSubscribe = computed(() => props.mode == 'subscribe')

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.agreement {
	font-size: 0.7rem;
	text-align: center;
	line-height: 1.4;
	color: #6a6d82;
	margin-bottom: 1rem;
}
</style>
